import { useEffect, useState } from "react";

const DEFAULT_LOGO = "/logo.png";

function AdminImageFallback({
  src,
  alt = "",
  className = "",
  uploadedImageClassName = "",
  fallbackClassName = "",
}) {
  const [hasError, setHasError] = useState(false);
  const useFallback = !src || hasError;

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <img
      src={useFallback ? DEFAULT_LOGO : src}
      alt={alt}
      className={[
        className,
        useFallback ? fallbackClassName : uploadedImageClassName,
      ]
        .filter(Boolean)
        .join(" ")}
      onError={() => setHasError(true)}
    />
  );
}

export default AdminImageFallback;